import Swiper from 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.mjs';
function initDzSwiper() {
  const el = document.querySelector('.dz-swiper');
  if (!el) return;

  if (el.swiper) {
    el.swiper.destroy(true, true);
  }

  new Swiper('.dz-swiper', {
    slidesPerView: 3.2,
    spaceBetween: 10,
    loop: false,
    navigation: {
      nextEl: '.dz-swiper-next',
      prevEl: '.dz-swiper-prev'
    },
    breakpoints: {
      0: {
        slidesPerView: 1.2,
        spaceBetween: 10
      },
      768: {
        slidesPerView: 2.2,
        spaceBetween: 10
      },
      1000: {
        slidesPerView: 3.2,
        spaceBetween: 10
      },
      1400: {
        slidesPerView: 3.2,
        spaceBetween: 10
      }
    }
  });
}

document.addEventListener('DOMContentLoaded', initDzSwiper);
document.addEventListener('shopify:section:load', initDzSwiper);


document.querySelectorAll('.header__menu-disclosure').forEach(el => {
  el.addEventListener('toggle', function () {
    const header = document.querySelector('x-header');

    if (this.open) {
      header.classList.add('menu-open');
    } else {
      // comprueba si hay otros abiertos
      const anyOpen = document.querySelector('.header__menu-disclosure[open]');
      if (!anyOpen) {
        header.classList.remove('menu-open');
      }
    }
  });
});





function initCarouselProgressBars() {
  const navs = document.querySelectorAll('carousel-navigation.page-dots--autoplay');

  navs.forEach((nav) => {
    const buttons = nav.querySelectorAll('.tap-area');
    if (!buttons.length) return;

    const duration = 6000; // pon aquí el mismo tiempo que tenga el autoplay

    // crea barra real dentro de cada botón si no existe
    buttons.forEach((btn) => {
      if (!btn.querySelector('.dz-bar')) {
        const bar = document.createElement('span');
        bar.className = 'dz-bar';
        btn.appendChild(bar);
      }
    });

    function restartCurrentBar() {
      buttons.forEach((btn) => {
        const bar = btn.querySelector('.dz-bar');
        if (!bar) return;

        bar.style.transition = 'none';
        bar.style.width = '0%';
      });

      const current = nav.querySelector('.tap-area[aria-current="true"]');
      if (!current) return;

      const currentBar = current.querySelector('.dz-bar');
      if (!currentBar) return;

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          currentBar.style.transition = `width ${duration}ms linear`;
          currentBar.style.width = '100%';
        });
      });
    }

    // observa cambio de slide
    const observer = new MutationObserver(() => {
      restartCurrentBar();
    });

    buttons.forEach((btn) => {
      observer.observe(btn, {
        attributes: true,
        attributeFilter: ['aria-current']
      });
    });

    restartCurrentBar();
  });
}

document.addEventListener('DOMContentLoaded', initCarouselProgressBars);
document.addEventListener('shopify:section:load', initCarouselProgressBars);